import { CdkDrag, CdkDragHandle, CdkDropList } from "@angular/cdk/drag-drop";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatNativeDateModule } from "@angular/material/core";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInput } from "@angular/material/input";
import { MatProgressBar } from "@angular/material/progress-bar";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatSortModule } from "@angular/material/sort";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTableModule,
} from "@angular/material/table";
import { MatTimepicker, MatTimepickerInput, MatTimepickerToggle } from "@angular/material/timepicker";
import { MatTooltip } from "@angular/material/tooltip";
import { RouterLink } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgxDatatableModule } from "@siemens/ngx-datatable";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { QuillEditorComponent } from "ngx-quill";
import { LoveItInputComponent } from "../form-controls/love-it-input/love-it-input.component";
import { LoveItSelectComponent } from "../form-controls/love-it-select/love-it-select.component";
import { LoveItTextareaTextvorlageComponent } from "../form-controls/love-it-textbaustein-textarea/love-it-textarea-textvorlage.component";
import { FormControlPipe } from "../pipes/form-control.pipe";
import { AktGeraetComponent } from "./akt-geraet/akt-geraet.component";
import { AktGeraeteListComponent } from "./akt-geraete-list/akt-geraete-list.component";
import { AktortBearbeitenComponent } from "./aktort-bearbeiten/aktort-bearbeiten.component";
import { AktsucheSuchbereichComponent } from "./aktsuche-suchbereich/aktsuche-suchbereich.component";
import { ComposeEmailComponent } from "./compose-email/compose-email.component";
import { EditContentModalComponent } from "./edit-content/edit-content-modal.component";
import { EmailAbwesenheitsbenachrichtigungComponent } from "./email-abwesenheitsbenachrichtigung/email-abwesenheitsbenachrichtigung.component";
import { EmailAbwesenheitsbenachrichtigungenListComponent } from "./email-abwesenheitsbenachrichtigungen-list/email-abwesenheitsbenachrichtigungen-list.component";
import { EmailContentComponent } from "./email-content/email-content.component";
import { FileOverviewComponent } from "./file-overview/file-overview.component";
import { GutachtenAuswahlComponent } from "./gutachten-auswahl/gutachten-auswahl.component";
import { GutachtenUebergebenComponent } from "./gutachten-uebergeben/gutachten-uebergeben.component";
import { HazardOverviewComponent } from "./hazard-overview/hazard-overview.component";
import { HeaderComponent } from "./header/header.component";
import { KalkulationFavoritenListComponent } from "./kalkulation-favoriten-list/kalkulation-favoriten-list.component";
import { KalkulationVorlagenListComponent } from "./kalkulation-vorlagen-list/kalkulation-vorlagen-list.component";
import { KontaktdatenAnsichtModalComponent } from "./kontaktdaten-ansicht-modal/kontaktdaten-ansicht-modal.component";
import { KontaktdatenComponent } from "./kontaktdaten/kontaktdaten.component";
import { FileViewerComponent } from "./pdf-viewer/file-viewer.component";
import { PopupInfoModalComponent } from "./popup-info-modal/popup-info-modal.component";
import { RueckfrageAnEmailComponent } from "./rueckfrage-an-email/rueckfrage-an-email.component";
import { TerminBearbeitenComponent } from "./termin-bearbeiten/termin-bearbeiten.component";
import { TerminHinzufuegenComponent } from "./termin-hinzufuegen/termin-hinzufuegen.component";
import { TerminWeitersetzenKommentarComponent } from "./termin-weitersetzen-kommentar/termin-weitersetzen-kommentar.component";
import { TermintabelleTerminlisteComponent } from "./termintabelle-terminliste/termintabelle-terminliste.component";
import { TextvorlageQuickSelectComponent } from "./textvorlage-quick-select/textvorlage-quick-select.component";
import { ResizeableModalDirective } from "../directives/resizeable-modal.directive";
import { ModalMoverComponent } from "./modal-mover/modal-mover.component";
import { ResizeCornerComponent } from "./resize-corner/resize-corner.component";

@NgModule({
  declarations: [
    FormControlPipe,
    ResizeableModalDirective,
    ModalMoverComponent,
    ResizeCornerComponent,
    HeaderComponent,
    HazardOverviewComponent,
    FileOverviewComponent,
    TerminBearbeitenComponent,
    TerminHinzufuegenComponent,
    AktortBearbeitenComponent,
    ComposeEmailComponent,
    RueckfrageAnEmailComponent,
    KontaktdatenComponent,
    KontaktdatenAnsichtModalComponent,
    TerminWeitersetzenKommentarComponent,
    EmailAbwesenheitsbenachrichtigungenListComponent,
    EmailAbwesenheitsbenachrichtigungComponent,
    EmailContentComponent,
    AktsucheSuchbereichComponent,
    TextvorlageQuickSelectComponent,
    LoveItTextareaTextvorlageComponent,
    AktGeraeteListComponent,
    AktGeraetComponent,
    LoveItInputComponent,
    FileViewerComponent,
    TermintabelleTerminlisteComponent,
    GutachtenUebergebenComponent,
    PopupInfoModalComponent,
    KalkulationFavoritenListComponent,
    KalkulationVorlagenListComponent,
    LoveItSelectComponent,
    EditContentModalComponent,
    GutachtenAuswahlComponent,
  ],
  exports: [
    FormControlPipe,
    ResizeableModalDirective,
    ModalMoverComponent,
    ResizeCornerComponent,
    HeaderComponent,
    HazardOverviewComponent,
    FileOverviewComponent,
    TerminBearbeitenComponent,
    TerminHinzufuegenComponent,
    AktortBearbeitenComponent,
    ComposeEmailComponent,
    RueckfrageAnEmailComponent,
    KontaktdatenComponent,
    KontaktdatenAnsichtModalComponent,
    TerminWeitersetzenKommentarComponent,
    EmailAbwesenheitsbenachrichtigungenListComponent,
    EmailAbwesenheitsbenachrichtigungComponent,
    EmailContentComponent,
    AktsucheSuchbereichComponent,
    TextvorlageQuickSelectComponent,
    LoveItTextareaTextvorlageComponent,
    AktGeraeteListComponent,
    AktGeraetComponent,
    FileViewerComponent,
    TermintabelleTerminlisteComponent,
    GutachtenUebergebenComponent,
    PopupInfoModalComponent,
    LoveItInputComponent,
    KalkulationFavoritenListComponent,
    KalkulationVorlagenListComponent,
    LoveItSelectComponent,
    EditContentModalComponent,
    GutachtenAuswahlComponent,
  ],
  imports: [
    IonicModule,
    CommonModule,
    NgOptimizedImage,
    RouterLink,
    MatTooltip,
    NgxDatatableModule,
    MatProgressBar,
    MatTableModule,
    MatHeaderCell,
    MatCell,
    MatIconModule,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    MatHeaderRowDef,
    MatCellDef,
    MatHeaderCellDef,
    MatColumnDef,
    CdkDrag,
    CdkDropList,
    MatSortModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinner,
    NgSelectModule,
    MatFormField,
    MatTimepicker,
    MatTimepickerToggle,
    MatInput,
    MatTimepickerInput,
    MatLabel,
    MatNativeDateModule,
    QuillEditorComponent,
    NgxExtendedPdfViewerModule,
    CdkDragHandle,
  ],
})
export class UtilComponentsModule {}
